import { CommonNodeViewWrapper } from '@/components/common/node-view-wrapper';
import { useIsEditorReadonly } from '@/hooks/use-is-editor-readonly';
import { useSiblingNodeInfo } from '@/hooks/use-sibling-node-info';
import { type ReactNodeViewProps, NodeViewContent } from '@tiptap/react';
import { PlusIcon } from 'lucide-react';
import { memo } from 'react';

const TestQuestionNodeView: React.FC<ReactNodeViewProps> = ({ selected, editor, getPos, decorations }) => {
    const isEditorReadonly = useIsEditorReadonly(editor);
    const addChoice = () => {
        const pos = getPos();
        if (typeof pos !== 'number') {
            return;
        }
        editor.commands.addTestQuestionChoice(pos);
    };

    const { nodeIndex } = useSiblingNodeInfo({
        editor,
        getPos,
        nodeTypeName: 'testQuestion',
    });

    const questionLabel = `Test Question ${nodeIndex + 1}`;

    return (
        <CommonNodeViewWrapper
            decorations={decorations}
            label={questionLabel}
            selected={selected}
            containerClassName="rounded-lg border-2 border-gray-200 bg-gray-50 dark:border-gray-700 dark:bg-gray-900/50"
            contentClassName="pt-3 px-1"
        >
            <div className="flex min-w-0 pl-5 pt-2 gap-1">
                <div className="min-w-0 w-full">
                    <NodeViewContent />
                    <div
                        className="mb-2 flex gap-2 justify-end"
                        contentEditable={false}
                    >
                        <button
                            onClick={addChoice}
                            disabled={isEditorReadonly}
                            className="group flex items-center justify-center gap-2 rounded-lg border-2 border-gray-300 px-4 py-1 text-gray-500 transition-all duration-200 hover:border-blue-400 hover:bg-blue-50 hover:text-blue-500 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:outline-none dark:border-gray-600 dark:text-gray-400 dark:hover:border-blue-500 dark:hover:bg-blue-950/20 dark:hover:text-blue-400 dark:focus:ring-offset-gray-900 disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            <PlusIcon className="h-4 w-4" />
                            <span className="text-sm font-medium">Add Choice</span>
                        </button>
                    </div>
                </div>
            </div>
        </CommonNodeViewWrapper>
    );
};

export default memo(TestQuestionNodeView);
